import { useLocation } from 'react-router-dom';

export const useClientId = (): number | null => {
  const { pathname } = useLocation();
  const clientId = pathname.split('/').find((p) => Number(p));

  return clientId ? Number(clientId) : null;
};
